import React, { ComponentProps, useState, useEffect, useCallback } from 'react';
import { ToggleButton } from 'react-native-paper';
import { IToggle } from '@nocode/types';
import { get, isEmpty, isNil } from 'lodash';
import createStyles from './style';
import PointIcon from '../CustomIcon';

type Props = ComponentProps<typeof ToggleButton>;

const Toggle: React.FC<IToggle> = ({
  attributes,
  onPress,
  changeInput,
  valueInputs,
  actions,
  groupActionId,
}) => {
  const [isActive, setIsActive] = useState<boolean>(valueInputs);
  const styles = createStyles(attributes);

  const handleToggle = (id: string, isAction: any) => {
    const sectionOnpress = get(attributes, `${id}.action`, {});

    if (groupActionId && isNil(isAction)) {
      if (isEmpty(sectionOnpress)) {
        onPress && onPress(undefined, { groupActionId });
      } else {
        onPress && onPress(id, { groupActionId });
      }
    } else {
      onPress && onPress(id);
    }
  };

  const childProps: Props = {
    status: 'unchecked',
    icon: isActive
      ? attributes.activeIcon === 'point'
        ? () => (
            <PointIcon
              width={attributes.size}
              height={attributes.size}
              fill={attributes.activeColor}
            />
          )
        : attributes.activeIcon
      : attributes.inactiveIcon === 'point'
      ? () => (
          <PointIcon
            width={attributes.size}
            height={attributes.size}
            fill={attributes.inactiveColor}
          />
        )
      : attributes.inactiveIcon,
    color: isActive ? attributes.activeColor : attributes.inactiveColor,
    size: attributes.size,
  };

  useEffect(() => {
    setIsActive(valueInputs);
  }, [valueInputs]);

  const handlePress = useCallback(async () => {
    changeInput && changeInput(!valueInputs);
    const { clickActions, activeActions, inactiveActions } = attributes;

    if (!onPress) return;

    if (isActive === true && activeActions) {
      await handleToggle('activeActions', activeActions);
      return;
    }

    if (isActive === false && inactiveActions) {
      await handleToggle('inactiveActions', inactiveActions);
      return;
    }

    return handleToggle('clickActions', clickActions);
  }, [valueInputs, isActive]);

  return (
    <ToggleButton onPress={handlePress} style={styles.icon} {...childProps} />
  );
};

export default Toggle;
